import React, { ReactElement } from 'react';
import { Grid, Typography } from '@material-ui/core';
import './Services.css';

export default function Services(): ReactElement {
    return (
        <>
            <div className="nlk-services">
                <Grid container spacing={5}>
                    <Grid item xs={12} md={6}>
                        <div className="services-img" />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <div className="services-text">
                            <Typography paragraph>Princip rada:</Typography>
                            <Typography paragraph>Lorem ispum dolor sit amet ....</Typography>
                            <Typography paragraph>
                                Heat oil in a (14- to 16-inch) paella pan or a large, deep skillet over medium-high
                                heat. Add chicken, shrimp and chorizo, and cook, stirring occasionally until lightly
                                browned, 6 to 8 minutes. Transfer shrimp to a large plate and set aside, leaving chicken
                                and chorizo in the pan. Add pimentón, bay leaves, garlic, tomatoes, onion, salt and
                                pepper, and cook, stirring often until thickened and fragrant, about 10 minutes. Add
                                saffron broth and remaining 4 1/2 cups chicken broth; bring to a boil.
                            </Typography>
                            <Typography paragraph>
                                Add rice and stir very gently to distribute. Top with artichokes and peppers, and cook
                                without stirring, until most of the liquid is absorbed, 15 to 18 minutes. Reduce heat to
                                medium-low, add reserved shrimp and mussels, tucking them down into the rice, and cook
                                again without stirring, until mussels have opened and rice is just tender, 5 to 7
                                minutes more. (Discard any mussels that don’t open.)
                            </Typography>
                            <Typography>
                                Set aside off of the heat to let rest for 10 minutes, and then serve.
                            </Typography>
                        </div>
                    </Grid>
                </Grid>
            </div>
        </>
    );
}
